import { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../../assets/logo.png';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de painéis de LED.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const closeMobile = () => setIsMobileOpen(false);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <a href="#" className="navbar__logo">
          <img src={logo} alt="ACJ Locações" />
        </a>

        <div className={`navbar__links ${isMobileOpen ? 'navbar__links--open' : ''}`}>
          <a href="#servicos" onClick={closeMobile}>Serviços</a>
          <a href="#portfolio" onClick={closeMobile}>Portfolio</a>
          <a href="#depoimentos" onClick={closeMobile}>Depoimentos</a>
          <a href="#contato" onClick={closeMobile}>Contato</a>
          <button className="button-primary navbar__cta" onClick={() => { handleWhatsAppClick(); closeMobile(); }}>
            <i className="fab fa-whatsapp"></i>
            Orçamento Grátis
          </button>
        </div>

        <button
          className={`navbar__hamburger ${isMobileOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {isMobileOpen && <div className="navbar__overlay" onClick={closeMobile}></div>}
    </nav>
  );
};

export default Navbar;
